import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TGetEWAPoliciesRequestSchema,
  TGetEWAPoliciesResponseSchema,
} from "./getEWAPolicies.schema";

export const getEWAPolicies = (axios: IAxiosInstance) => {
  return async ({
    companyID,
    ewaPolicyID,
    stateJurisdiction,
  }: TGetEWAPoliciesRequestSchema) => {
    const { data } = await axios.noRetry.get<
      IApiResponse<TGetEWAPoliciesResponseSchema>
    >(`/api/ewa/policies`, {
      params: {
        companyID,
        ewa_policy_id: ewaPolicyID,
        state_jurisdiction: stateJurisdiction,
      },
    });

    if (data.success) {
      return data.data;
    }

    throw new Error("Something went wrong");
  };
};
